import React, { forwardRef, useState, useMemo, useCallback, useRef } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { Form } from 'antd'
import { uniqBy, isEmpty } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';

const GitGuardianMappingForm = forwardRef(function GitGuardianMappingForm({disableProjectFields = false, ...props}, ref) {
  const [form] = Form.useForm();
  const [mappedSourceList] = useState(() => {
    if (props.record) {
      const { sourceName, sourceId } = props.record;
      const sourceIdArr = sourceId.split(',');
      const sourceNameArr = sourceName.split(',');
      return{ 
        source: sourceIdArr.map((id, index) => ({id, name: sourceNameArr[index]}))
      }
    }
    return { source: [] }
  })
  const repoRef = useRef({ source: mappedSourceList.source });

  const fetchSources = useCallback((params) => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, params);
    promise.then((response) => {
      const { projects } = response;
      if (mappedSourceList['source'].length > 0 && !isEmpty(response.projects)) {
        response.projects = uniqBy([...response.projects, ...mappedSourceList['source']], 'name');
      }

      repoRef.current['source'] = uniqBy([...projects, ...repoRef.current['source']], 'name')
    });
    return { promise, cancel }
  }, [props.toolName, mappedSourceList]);


  const getExtraFieldsData = useCallback((config) => {
    const { sourceId } = config;

    const data = repoRef.current.source.reduce((acc,cv) =>{
      const { id, name } = cv;
      if(sourceId.includes(id)){
        acc.id.push(id);
        acc.name.push(name);
      }
      return acc;
    },{id:[],name:[]})

    return ({
      sourceId: data.id.join(),
      sourceName: data.name.join(),
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    });
  }, []);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return {  sourceId: config.sourceId.split(','),
    //send the property received in config
    ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
   };
    }, []);

  const projectChangeHandler = useCallback((value, field, selectValue) => {
    const { name } = field;
    const configurations = form.getFieldValue("configurations");
    let updatedConfiguration = [
      ...configurations
    ];
    updatedConfiguration[name] = {
      ...updatedConfiguration[name],
    }
    form.setFieldsValue({ configurations: updatedConfiguration })
  }, [form])

  const extraFields = useMemo(() => ([
    {
      name: 'sourceId',
      colSpan: '12',
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      label: 'Source Name',
      disabled: disableProjectFields,
      required: true,
      props: {
        api: fetchSources,
        apiParams: { login_id: props.loginConfigId },
        onChange: projectChangeHandler,
        autoFocus: !disableProjectFields,
        mode: "multiple"
      }
    }
  ]), [fetchSources, projectChangeHandler, props.loginConfigId, disableProjectFields]);

  return (
    <GenericMappingForm
      form={form}
      ref={ref}
      title="Map GitGuardian Sources"
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default GitGuardianMappingForm;
